import {
  PARENT_ROLES,
  PRIVILEGES,
  REPORTS,
  SUB_ROLES,
} from "./utility/TextLabels";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { msalConfig, scope } from "./authConfig";
import Box from "@mui/material/Box";
import PrivilegesPage from "./features/PrivilegesPage/PrivilegesPage";
import React, { useEffect, useState } from "react";
import ReportsPage from "./features/ReportsPage/ReportsPage";
import ParentRolesPage from "./features/ParentRolesPage/ParentRolesPage";
import Sidebar from "./components/Sidebar/Sidebar";
import Title from "./components/Title/Title";
import Topbar from "./components/Topbar/Topbar";
import SubRolesPage from "./features/SubRolesPage/SubRolesPage";
import Footer from "./components/Footer/Footer";

export const appName: string = "ConfigurationModule";
export const appVersion: string = "0.0.2";

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const [title, setTitle] = useState("rettigheder");

  useEffect(() => {
    switch (location.pathname) {
      case "/rettigheder":
        setTitle(PRIVILEGES);
        break;
      case "/roller":
        setTitle(PARENT_ROLES);
        break;
      case "/underroller":
        setTitle(SUB_ROLES);
        break;
      case "/rapporter":
        setTitle(REPORTS);
        break;
      default:
        setTitle(PRIVILEGES);
    }
  }, [location.pathname]);

  return (
    <>
      <Topbar />
      <Title titleText={title} />
      <Box display="flex">
        <Sidebar />
        <Box flexGrow={1} marginTop="20px" marginLeft="40px" marginRight="40px">
          {children}
        </Box>
      </Box>
      <Footer />
    </>
  );
};
const msalInstance = new PublicClientApplication(msalConfig);

const LoginPage = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const checkAccountsAndLogin = async () => {
      try {
        await instance.handleRedirectPromise();
        const accounts = instance.getAllAccounts();
        if (accounts.length === 0) {
          await instance.loginRedirect({
            scopes: scope,
          });
        }
        const tokens = await instance.acquireTokenSilent({
          ...{
            scopes: scope,
          },
          account: accounts[0],
        });
        localStorage.setItem("tokens", JSON.stringify(tokens));
      } catch (error) {
        console.error(
          "An error occured while handling MSAL login. Error: " + error
        );
      }
    };
    checkAccountsAndLogin();
  }, [instance]);

  return <></>;
};

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<PrivilegesPage />} />
              <Route path="/rettigheder" element={<PrivilegesPage />} />
              <Route path="/roller" element={<ParentRolesPage />} />
              <Route path="/underroller" element={<SubRolesPage />} />
              <Route path="/rapporter" element={<ReportsPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
};

export default App;
